import { donateHeroImage, donateHeroMobileImage } from "../../assets/images";

export const heroData = [
	{
		imageSource: [donateHeroImage, donateHeroMobileImage],
		heading: "Donate Now",
	},
];

export const donateData = [
	{
		title: "Why you should Donate for us",
		description:
			"Your generous support will go directly to providing support and assistance to our community’s most vulnerable including children, those living with a mental illness, victims of violence and the homeless. Help build our community and inspire hope today.",
	},
];

export const donateCardsData = {
	firstCard: {
		heading: "Donate",
		description:
			"We support our immediate community by operating a local food bank and providing basic amenities such as clothing, shelter, clean water, etc...",
		linkTo: "/donate-once",
		color: "#FFF9F3",
	},
	secondCard: {
		heading: "Sponsor a meal",
		description:
			"We support our immediate community by operating a local food bank and providing basic amenities such as clothing, shelter, clean water, etc...",
		linkTo: "/sponsor-a-meal",
		color: "#FAF5FF",
	},
	thirdCard: {
		heading: "Donate Monthly",
		description:
			"We support our immediate community by operating a local bank and providing basic amenities such as clothing, shelter, clean water, etc...",
		linkTo: "/donate-monthly",
		color: "#F4FCFA",
	},
	fourthCard: {
		heading: "Save an Hospital patient",
		description:
			"We support our immediate community by operating a local food bank and providing basic amenities such as clothing, shelter, clean water, etc...",
		linkTo: "/save-an-hospital-patient",
		color: "#FCEBEF",
	},
	fifthCard: {
		heading: "Donate from our Amazon Wish list ",
		description:
			"We support our immediate community by operating a local food bank and providing basic amenities such as clothing, shelter, clean water, etc...",
		linkTo: "https://www.amazon.ca/hz/wishlist/ls/Q8SBVPLOCVJN?ref_=wl_share",
		color: "#FAF5FF",
	},
};

export const amounts = [
	"$1500",
	"$750",
	"$500",
	"$250",
	"$100",
	"$50",
	"Others",
];

export const requiredFormData = [
	{
		label: "firstname",
		type: "text",
		registerName: "firstname",
		errorMessage: "",
	},
	{
		label: "lastname",
		type: "text",
		registerName: "lastname",
		errorMessage: "",
	},
	{
		label: "email",
		type: "email",
		registerName: "email",
		errorMessage: "",
	},
	{
		label: "phone",
		type: "tel",
		registerName: "phone",
		errorMessage: "",
	},
	{
		label: "country",
		type: "text",
		registerName: "country",
		errorMessage: "",
	},
	{
		label: "designation",
		type: "text",
		registerName: "designation",
		errorMessage: "",
	},
];

export const designationData = [
	"Greatest Need",
	"Health Services",
	"Move Out Program",
	"Meal Sponsorship",
];
